import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import * as actions from './_actions';
import * as types from './_actionTypes';
import SMEContentAPI from '../../../../utils/API/BackendHelper/sme/content';

// Fetch SME Courses
function* fetchSMECoursesSaga() {
  try {
    const response = yield call(SMEContentAPI.getMyCourses);
    
    if (response.success) {
      yield put(actions.fetchSMECoursesSuccess(response.data));
    } else {
      yield put(actions.fetchSMECoursesFailure(response.message || 'Failed to fetch courses'));
    }
  } catch (error) {
    yield put(actions.fetchSMECoursesFailure(error.message || 'An error occurred'));
  }
}

// Fetch Course Contents
function* fetchSMECourseContentsSaga(action) {
  try {
    const { courseId, filters } = action.payload;
    const response = yield call(SMEContentAPI.getCourseContents, courseId, filters);
    
    if (response.success) {
      yield put(actions.fetchSMECourseContentsSuccess(response.data));
    } else {
      yield put(actions.fetchSMECourseContentsFailure(response.message || 'Failed to fetch contents'));
    }
  } catch (error) {
    yield put(actions.fetchSMECourseContentsFailure(error.message || 'An error occurred'));
  }
}

// Create Content
function* createSMEContentSaga(action) {
  try {
    const { courseId, contentData } = action.payload;
    const response = yield call(SMEContentAPI.createContent, courseId, contentData);
    
    if (response.success) {
      yield put(actions.createSMEContentSuccess(response.data));
      // Optionally refresh the content list
      yield put(actions.fetchSMECourseContentsRequest(courseId));
    } else {
      yield put(actions.createSMEContentFailure(response.message || 'Failed to create content'));
    }
  } catch (error) {
    yield put(actions.createSMEContentFailure(error.message || 'An error occurred'));
  }
}

// Update Content
function* updateSMEContentSaga(action) {
  try {
    const { contentId, contentData } = action.payload;
    const response = yield call(SMEContentAPI.updateContent, contentId, contentData);
    
    if (response.success) {
      yield put(actions.updateSMEContentSuccess(response.data));
    } else {
      yield put(actions.updateSMEContentFailure(response.message || 'Failed to update content'));
    }
  } catch (error) {
    yield put(actions.updateSMEContentFailure(error.message || 'An error occurred'));
  }
}

// Delete Content
function* deleteSMEContentSaga(action) {
  try {
    const contentId = action.payload;
    const response = yield call(SMEContentAPI.deleteContent, contentId);
    
    if (response.success) {
      yield put(actions.deleteSMEContentSuccess(contentId));
    } else {
      yield put(actions.deleteSMEContentFailure(response.message || 'Failed to delete content'));
    }
  } catch (error) {
    yield put(actions.deleteSMEContentFailure(error.message || 'An error occurred'));
  }
}

// Fetch Single Content by ID
function* fetchSMEContentByIdSaga(action) {
  try {
    const contentId = action.payload;
    const response = yield call(SMEContentAPI.getContentById, contentId);

    if (response.success) {
      yield put(actions.fetchSMEContentByIdSuccess(response.data));
    } else {
      yield put(actions.fetchSMEContentByIdFailure(response.message || 'Failed to fetch content'));
    }
  } catch (error) {
    yield put(actions.fetchSMEContentByIdFailure(error.message || 'An error occurred'));
  }
}

// Fetch Statistics
function* fetchSMEContentStatsSaga(action) {
  try {
    const courseId = action.payload;
    const response = yield call(SMEContentAPI.getContentStatistics, courseId);
    
    if (response.success) {
      yield put(actions.fetchSMEContentStatsSuccess(response.data));
    } else {
      yield put(actions.fetchSMEContentStatsFailure(response.message || 'Failed to fetch statistics'));
    }
  } catch (error) {
    yield put(actions.fetchSMEContentStatsFailure(error.message || 'An error occurred'));
  }
}

// Root Saga
function* smeContentSaga() {
  yield takeLatest(types.FETCH_SME_COURSES_REQUEST, fetchSMECoursesSaga);
  yield takeLatest(types.FETCH_SME_COURSE_CONTENTS_REQUEST, fetchSMECourseContentsSaga);
  yield takeLatest(types.FETCH_SME_CONTENT_BY_ID_REQUEST, fetchSMEContentByIdSaga);
  yield takeEvery(types.CREATE_SME_CONTENT_REQUEST, createSMEContentSaga);
  yield takeEvery(types.UPDATE_SME_CONTENT_REQUEST, updateSMEContentSaga);
  yield takeEvery(types.DELETE_SME_CONTENT_REQUEST, deleteSMEContentSaga);
  yield takeLatest(types.FETCH_SME_CONTENT_STATS_REQUEST, fetchSMEContentStatsSaga);
}

export default smeContentSaga;
